<div class="loan-purpose">
    <h2 class="step-title">{{ title }}</h2>
    
    <div class="field">
        <div class="control">
            <select
                class="select is-large" type="text" formControlName="cashOutReason"
                #cashOutReason (change)="snap()" name="cashOutReason" value=""
                *ngIf="debtSettlement; else plOptions"
            >
                <option value="" disabled>Select A Loan Purpose</option>
                <option value="debt-consolidation">Debt Consolidation</option>
                <option value="reduce-debt">Reduce High Interest debt</option>
                <option value="pay-off-credit-cards">Pay Off Credit Cards</option>
            </select>
            <ng-template #plOptions>
                <select
                    class="select is-large" type="text" formControlName="cashOutReason"
                    #cashOutReason (change)="snap()" name="cashOutReason" value=""
                >
                    <option value="" disabled>Select A Loan Purpose</option>
                    <option value="debt-consolidation">Debt Consolidation</option>
                    <option value="reduce-debt">Reduce High Interest debt</option>
                    <option value="pay-off-credit-cards">Pay Off Credit Cards</option>
                    <option value="education">Education</option>
                    <option value="medical">Medical</option>
                    <option value="emergency">Emergency</option>
                    <option value="other">Other</option>
                </select>
            </ng-template>
            
        </div>
    </div>
        
    <div>
        <button class="button continue is-large has-shadow-small"  (click)="submit()">
            Continue
            <i class="fas fa-chevron-right"></i>
        </button> 
    </div>
</div>